<template>
  <div :class="isApp == true ? '' : 'content'">
    <Header></Header>
    <div class="main" v-show="isApp == true ? false : true">
      <!-- <div class="main_left">
        <div class="index-buygift">
          <img src="../assets/index/btn-buygift-top.gif" alt="" />
          <a class="btn-buygift buy" href="">
            <img v-show="isbuyIconEn" src="../assets/index/buy_en.png" alt="" />
            <img v-show="isbuyIconZh" src="../assets/index/buy_zh.png" alt="" />
          </a>
        </div>
        <div class="index-transfer">
          <img src="../assets/index/btn-transfer-top.gif" alt="" />
          <a class="btn-transfer" href="">
            <img
              v-show="isbuyIconEn"
              src="../assets/index/gift_en.png"
              alt=""
            />
            <img
              v-show="isbuyIconZh"
              src="../assets/index/gift_zh.png"
              alt=""
            />
          </a>
        </div>

        <div class="side-info-wrap">
          <div class="side-info-gradient">
            <div class="dw-motion">
              <img src="../assets/index/yao.gif" alt="" />
            </div>
           <div class="xiazai">
              <div class="xia_left">
                <div class="">
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-ios.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank"
                    ><div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i></div
                  ></a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_center">
                    <img src="../assets/index/ma.png" alt="" />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_btm">
                    <img src="../assets/index/ma2.png" alt="" />
                  </a>
                </div>
              </div>
          <div class="xia_right subb">
                <div class="" @click="goDown">
                  <a class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-akp.png"
                    />
                  </a>
                  <a>
                    <div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i>
                    </div>
                  </a>
                  <a class="xia_left_center"
                    ><img src="../assets/index/apk.png" alt=""
                  /></a>
                </div>
              </div>
            </div>

            <div class="fbBtn_wrap" style="padding:0.2rem">
              <a href="https://t.me/Tiger777com" target="_blank">
                  <img src="../assets/index/liaotian.png" style="width:9.375rem;height:3.125rem" alt="">
                </a>
            </div>
          </div>
        </div>
      </div> -->
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation">{{ $t("teaching.home") }}>>{{ $t("teaching.teach") }}>>{{ item1 }}</div>
        <div class="big_border">
          <div class="smal_border">
            <!-- 银行赠礼，vip，人气值，道具系统 -->
            <div class="qusetion_list">
              <div
                :class="
                  active == index
                    ? 'qusetion_list_title_sub'
                    : 'qusetion_list_title'
                "
                v-for="(item, index) in questionList"
                :key="index"
                @click="changeQuertion(item, index)"
              >
                <div class="qusetion_list_category subb">{{ item.category }}</div>
              </div>
            </div>
          <!-- 银行赠礼 -->
            <div class="zan"></div>
            <div class="" style="itemtest">
              <div class="itemSub subb">
                <span
                  :class="
                    activeSub == index ? 'itemSub_type_sub' : 'itemSub_type'
                  "
                  v-for="(item, index) in allList"
                  :key="index"
                  @click="changItemSub(item, index)"
                  >{{ item.category }}</span
                >
              </div>
            </div>
            <div class="choice_img">
              <img :src="this.choiceImg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="isapp" v-show="isApp == false ? false : true">
      <div class="">
        <div class="isapp_big_border">
          <div class="isapp_smal_border">
            <div class="isapp_qusetion_list">
              <div
                :class="
                  active == index
                    ? 'isapp_qusetion_list_title_sub'
                    : 'isapp_qusetion_list_title'
                "
                v-for="(item, index) in questionList"
                :key="index"
                @click="changeQuertion(item, index)"
              >
                <div class="qusetion_list_category subb">{{ item.category }}</div>
              </div>
            </div>
            <div class="zan"></div>
            <div class="" style="itemtest">
              <div class="itemSub subb">
                <span
                  :class="
                    activeSub == index ? 'isapp_itemSub_type_sub' : 'isapp_itemSub_type'
                  "
                  v-for="(item, index) in allList"
                  :key="index"
                  @click="changItemSub(item, index)"
                  >{{ item.category }}</span
                >
              </div>
            </div>
            <div class="isapp_choice_img">
              <img :src="this.choiceImg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import "../assets/h5/teaching.css";

export default {
  data() {
    return {
      lang:'4',
      isbuyIconEn: true,
      isbuyIconZh: false,
      item1: "",
      choiceImg: "",
      allList: [],
      active: 0,
      activeSub: 0,
      questionList: [],
    };
  },
  computed: {
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
    }),
  },
  created() {
    this.showAll();
    this.changeIcon();
    this.getBannerList()
  },
  methods: {
    goDown(){
     this.$router.push('/Down')
    },
     getBannerList() {
      var _that = this
      let obj = {
        // 服务端只有中文
        lang:_that.lang
      };
      this.$FucPost(this.$store.state.ip + "/getTeachingList", obj)
        .then(function (res) {
          // console.log(res);
          _that.questionList=res
          // console.log('aa',_that.questionList[1].data)
          let aa = _that.questionList[0].data;
          let arr = [];
          for (let i = 0; i < aa.length; i++) {
             let obj = {
                 category: aa[i].category,
                 image: aa[i].image,
                 content:aa[i].content
              };
          arr.push(obj);
          }
          _that.allList = arr;
          // console.log('_that.allList',_that.allList)
          //第一张图
          _that.choiceImg = _that.allList[0].image;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeQuertion(e, index) {
      // console.log(e)
      this.active = index;
      this.allList = e.data;
      this.choiceImg = e.data[0].image;
      this.item1 = e.category;
    },
    showAll() {
      var langNum=localStorage.getItem("lang");
      // console.log('langNum',langNum)
      if(langNum=='zh'){
        this.lang=3
      }
      if(langNum=='en'){
        this.lang=4
      }
    },
    changItemSub(e, index) {
      // console.log("changItemSubE", e);
      this.activeSub = index;
      this.choiceImg = e.image;
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
// .content {
//   width: 100%;
//   background: #ad0000
//     url("https://www.jinjinjin777.com/static/images/bg-pc-head.jpg") center top
//     no-repeat;
//   background-size: 100% auto;
// }
.main_content {
  width: 75%;
  float: right;
}
.big_border {
  padding: 0.625rem 0;
  background-color: rgb(188, 152, 30);
  width: 100%;
  //   height: 50rem;
  border-radius: 0.625rem;
}
.smal_border {
  background-color: rgb(215, 206, 176);
  width: 54.375rem;
  margin: 0 auto;
  //   height: 43.75rem;
  border-radius: 0.625rem;
}
.qusetion_list {
  width: 85%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  flex-wrap: wrap;
}
.qusetion_list_title div{  
    width: 100%;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}
.qusetion_list_title_sub div{ 
    width: 100%;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}
.qusetion_list_title {
  
  align-items: center;
  margin-top: 0.625rem;
  background-image: linear-gradient(
    #a0bab7 0%,
    #6a8387 20%,
    #404c58 50%,
    #4e5f69 75%,
    #7a999b 100%
  );
  width: 18%;
  padding: 0.625rem 0.625rem;
  border-radius: 0.625rem;
  color: aliceblue;
  font-weight: 600;
  margin:0.3125rem 0.625rem;
}
.qusetion_list_title_sub {
  
  align-items: center;
  margin-top: 0.625rem;
  box-shadow: 0 0 0.125rem #40d2eb inset, 0 0 0.125rem #40d2eb inset;
  background-image: linear-gradient(
    #3ab2cd 0%,
    #1d67be 25%,
    #203eac 50%,
    #2553b3 75%,
    #297bc7 100%
  );
  width: 18%;
  padding: 0.625rem 0.625rem;
  border-radius: 0.625rem;
  color: aliceblue;
  font-weight: 600;
  margin:0.3125rem 0.625rem;
}
.itemtest {
}
.zan {
  height: 0.625rem;
}
.itemSub {
  // display: flex;
  // flex-direction: row;
  // justify-content: space-around;
}
.itemSub_type {
  padding: 0.625rem 1.25rem;
  color: #2e64a7;
  font-size: 0.9375rem;
}
.itemSub_type_sub {
  padding: 0.625rem 1.25rem;
  color: #fff0a8;
  text-shadow: 0 0 0.1875rem #670005, 0 0 0.1875rem #670005,
    0 0 0.1875rem #670005, 0 0 0.1875rem #670005, 0 0 0.3125rem #670005,
    0 0 0.3125rem #670005, 0 0 0.3125rem #670005, 0 0 0.3125rem #670005,
    0 0 0.3125rem #670005;
  font-size: 0.9375rem;
}
.choice_img {
  padding: 0.625rem 0;
}
.choice_img img {
  width: 50rem;
}
.xia_left_center img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xia_left_btm img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xiazaitu{
 width: 5.9375rem;
  height: 1.9375rem;
}
.qusetion_list_category{
  // width: 100%;
}
</style>
